import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';


export const Container = styled.View`
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  padding: 0 24px;
`;

export const Form = styled.View``;

export const InputGroup = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const PickerContainer = styled.View`
  margin: 0 24px;
`;

export const LinkButtonContainer = styled.View`

  flex-direction: row;

`;

export const LinkButton = styled.TouchableOpacity`
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.blue};
  border-style: solid;
`;

export const LinkButtonText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.blue};
`;



export const Footer = styled.View`
  padding: 0 24px;

 margin-top: ${RFValue(16)}px;
  width: 100%;

`;

export const InputRow = styled.View`
  flex-direction: row;
  align-items: center;
  gap:${RFValue(12)}px;
`;